import Api from '@api'
import { cloneDeep } from 'lodash'

const state = {
  title: '',
  images: [],
  categories: [],
  categoryIndex: 0,
  projects: [],
  article: {
    components: []
  },
  slider: {
    images: []
  },
  banner: {
    image: '',
    text: {
      wysiwyg: []
    }
  },
  transition: ''
}

const getters = {
  getImages: state => state.images,
  getTitle: state => state.title,
  getArticle: state => state.article,
  getCategories: state => state.categories,
  getProjects: state => state.projects,
  getBanner: state => state.banner,
  getSlider: state => state.slider,
  getTransition: state => state.transition,
  getCategoryIndex: state => state.categoryIndex
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_IMAGES: (state, array) => {
    state.images = [ ...array ]
  },
  UPDATE_BANNER: (state, object) => {
    state.banner = { ...object }
  },
  UPDATE_ARTICLE: (state, object) => {
    state.article = { ...object }
  },
  UPDATE_CATEGORIES: (state, array) => {
    state.categories = [ ...array ]
  },
  UPDATE_CATEGORY_INDEX: (state, number) => {
    state.categoryIndex = number
  },
  UPDATE_PROJECTS: (state, array) => {
    state.projects = [ ...array ]
  },
  UPDATE_TRANSITION: (state, string) => {
    state.transition = string
  }
}

const actions = {
  async fetchGetPage ({ dispatch }, { name, params }) {
    const response = await Api.getPageContent(name, params)
    dispatch('updatePageContent', response)
  },
  async fetchGetWorkPage ({ dispatch }, { name, params }) {
    const response = await Api.getWorkPageContent(name, params)
    dispatch('updatePageContent', response)
  },
  updatePageContent: ({ dispatch }, response) => {
    dispatch('updateTitle', response.title || '')
    dispatch('updateImages', response.images || [])
    dispatch('updateArticle', response.article || { components: [] })
    dispatch('updateCategories', response.categories || [])
    dispatch('updateProjects', response.projects || [])
    dispatch('updateBanner', response.banner || { image: '', text: { wysiwyg: [] } })
  },
  updateTitle: ({ commit }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateImages: ({ commit }, images) => {
    commit('UPDATE_IMAGES', cloneDeep(images))
  },
  updateArticle: ({ commit }, article) => {
    commit('UPDATE_ARTICLE', cloneDeep(article))
  },
  updateBanner: ({ commit }, banner) => {
    commit('UPDATE_BANNER', cloneDeep(banner))
  },
  updateCategories: ({ commit, dispatch, state }, categories) => {
    commit('UPDATE_CATEGORIES', cloneDeep(categories))
    const images = cloneDeep(state.images)
    categories.forEach((category, index) => {
      if (category.image) {
        images.push(category.image)
      }
    })
    dispatch('updateImages', images)
  },
  updateCategoryIndex: ({ commit }, index) => {
    commit('UPDATE_CATEGORY_INDEX', index)
  },
  updateProjects: ({ commit }, projects) => {
    commit('UPDATE_PROJECTS', cloneDeep(projects))
  },
  // updateProjects: ({ commit, getters }, projects) => {
  //   const elements = cloneDeep(projects)
  //   const images = elements.map(project => cloneDeep(project.image))
  //   const firstImage = cloneDeep(getters.getImages)
  //   if (images.length) commit('UPDATE_IMAGES', [ ...firstImage, ...images ])
  //   commit('UPDATE_PROJECTS', elements)
  // },
  updateTransition: ({ commit }, status) => {
    commit('UPDATE_TRANSITION', status)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
